{
  "name": "snacktesting",
  "type": "module",
  "license": "MIT",
  "version": "0.0.1",
  "author": "Snack Money Team",
  "description": "A CLI tool for sending USDC payments on Twitter and Farcaster using x402.",
  "bin": {
    "snacktesting": "./dist/src/index.js"
  },
  "module": "./dist/src/index.js",
  "types": "./dist/src/index.d.ts",
  "main": "dist/src/index.js",
  "files": [
    "dist"
  ],
  "keywords": [
    "cli",
    "x402",
    "usdc",
    "twitter",
    "farcaster",
    "snackmoney"
  ],
  "scripts": {
    "pay": "tsx pay.ts",
    "batch-pay": "tsx batch_pay.ts",
    "create-reward-distribution": "tsx create_reward_distribution",
    "confirm-reward-distribution": "tsx confirm_reward_distribution",
    "format": "prettier -c .prettierrc --write \"**/*.{ts,js,cjs,json,md}\"",
    "format:check": "prettier -c .prettierrc --check \"**/*.{ts,js,cjs,json,md}\"",
    "lint": "eslint . --ext .ts --fix",
    "build": "tsup",
    "lint:check": "eslint . --ext .ts"
  },
  "dependencies": {
    "axios": "^1.7.9",
    "chalk": "^5.4.1",
    "commander": "^14.0.0",
    "dotenv": "^16.5.0",
    "gradient-string": "^3.0.0",
    "inquirer": "^12.8.2",
    "viem": "^2.23.1",
    "x402-axios": "latest"
  },
  "devDependencies": {
    "@eslint/js": "^9.24.0",
    "@types/gradient-string": "^1.1.6",
    "@types/minimist": "^1.2.5",
    "@types/node": "^24.0.12",
    "@typescript-eslint/eslint-plugin": "^8.29.1",
    "@typescript-eslint/parser": "^8.29.1",
    "eslint": "^9.24.0",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-jsdoc": "^50.6.9",
    "eslint-plugin-prettier": "^5.2.6",
    "minimist": "^1.2.8",
    "prettier": "3.5.2",
    "tsup": "^8.5.0",
    "tsx": "^4.7.0",
    "typescript": "^5.3.0"
  },
  "packageManager": "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"
}
